import React from 'react';
import {Img} from 'react-image';

import arrayUtils from '@/utils/arrayUtils';

const AppImage = ({src, alt = '', defaultImageSrcSet, ...restProps}) => {
    const srcSet = arrayUtils.toArray(src, defaultImageSrcSet);
    const altText = alt === null ? '' : alt;

    return <Img alt={altText} {...restProps} src={srcSet} />;
};

export default AppImage;
